import { NativeModules } from 'react-native';
import type { LatLng } from '../types';

const { AMapUtil } = NativeModules;

export class AMapUtils {
    public static calculateLineDistance(origins: LatLng[], destinations: LatLng[]): Promise<number[]> {
        return AMapUtil.calculateLineDistance(origins, destinations);
    }
}
